import Layout from "../components/layout/Layout";
import CustomerList from "../components/page/CustomerList";

const CustomersPage = () => {
  return (
    <Layout>
      <CustomerList />
    </Layout>
  );
};
export default CustomersPage;
